import { jsx as _jsx } from "react/jsx-runtime";
import { ShowBase } from "react-admin";
import { ElectionEventTabs } from "./ElectionEventTabs";
export var ElectionEventBaseTabs = function () {
    return (_jsx(ShowBase, { children: _jsx(ElectionEventTabs, {}) }));
};
